import {
  ref, watch, computed, getCurrentInstance,
} from '@vue/composition-api';
import store from '@/store';
import { showToast } from '@/@core/utils/utils'

export default function useUsersList() {
  const vm = getCurrentInstance().proxy;
  const refListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: false, thAttr: { width: 40 } },
    {
      key: 'name',
      sortable: false,
      label: 'Tên',
      thAttr: {},
    },
    {
      key: 'code',
      sortable: false,
      label: 'Viết tắt',
      Attr: { width: 100 },
    },
    // {
    //   key: 'type',
    //   sortable: false,
    //   label: 'Loại',
    //   thAttr: { width: 200 },
    // },
    {
      key: 'parent_id',
      sortable: false,
      label: 'Mục cha',
      thAttr: { width: 200 },
    }, {
      key: 'is_director',
      sortable: false,
      label: 'Là phòng giám đốc',
      thAttr: { width: 150 },
    },
    {
      key: 'actions',
      label: 'Hành động',
      thAttr: { width: 200 },
      thClass: 'text-right',
      tdClass: 'text-right',
    },
  ];
  const loading = ref(false);
  const perPage = ref(10);
  const totalEntries = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 30, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('id');
  const isSortDirDesc = ref(true);
  const departmentFilter = ref(0);
  const departmentFilterIsDirector = ref(null);
  const departmentOptions = ref([]);
  const statusFilter = ref(null);
  const isPaginate = ref(1);
  const withParent = ref(1);
  const withChildren = ref(1);
  const itemsData = ref([]);
  const itemsDataTree = ref([]);
  const levelOptions = [
    { value: 1, text: '1' },
    { value: 2, text: '2' },
    { value: 3, text: '3' },
    { value: 4, text: '4' },
  ];
  const typeOptions = [
    { value: 0, text: 'Phòng' },
    { value: 1, text: 'Ban' },
    { value: 2, text: 'Kênh' },
    { value: 3, text: 'Đài' },
  ];

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalEntries.value,
    };
  });

  const fetchDepartments = () => {
    loading.value = true;
    store
      .dispatch('departments/fetchDepartments', {
        keyword: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        isPaginate: isPaginate.value,
        parentId: departmentFilter.value ? departmentFilter.value : '',
        isDirector: departmentFilterIsDirector.value ? departmentFilterIsDirector.value : '',
        withParent: withParent.value,
        withChildren: withChildren.value,
      })
      .then((response) => {
        loading.value = false;
        if (response.status === 200) {
          const items = response.data.data.data;
          const { total } = response.data.data;
          totalEntries.value = total;
          itemsData.value = items;
        }
      });
  };
  const normalizerTreeList = (node) => ({ children: node.children && node.children.length ? node.children : 0 })

  const fetchDepartmentOptions = (callback) => {
    store
      .dispatch('departments/fetchDepartmentOptions', {
        parentId: 0,
        isPaginate: 0,
        withParent: 0,
        withChildren: 0,
        deepLevel: 3,
        type: 'tree',
      })
      .then((res) => {
        loading.value = false;
        if (res.status === 200) {
          const items = res.data.data;
          items.forEach((root) => {
            const item = {
              id: root.id,
              label: root.name,
              children: [],
            };
            if (root.childrens.length) {
              root.childrens.forEach((c1) => {
                const item1 = {
                  id: c1.id,
                  label: c1.name,
                  children: [],
                }
                if (c1.childrens.length) {
                  c1.childrens.forEach((c2) => {
                    const item2 = {
                      id: c2.id,
                      label: c2.name,
                      children: [],
                    }
                    if (c2.childrens.length) {
                      c2.childrens.forEach((c3) => {
                        const item3 = {
                          id: c3.id,
                          label: c3.name,
                          children: [],
                        }
                        if (c3.childrens.length) {
                          c3.childrens.forEach((c4) => {
                            const item4 = {
                              id: c4.id,
                              label: c4.name,
                              children: [],
                            }
                            if (c4.childrens.length) {
                              c4.childrens.forEach((c5) => {
                                const item5 = {
                                  id: c5.id,
                                  label: c5.name,
                                  children: [],
                                }
                                item4.children.push(item5);
                              })
                            }
                            item3.children.push(item4);
                          })
                        }
                        item2.children.push(item3);
                      })
                    }
                    item1.children.push(item2);
                  })
                }
                item.children.push(item1);
              })
            }
            departmentOptions.value.push(item);
          });
        }
      });
  };

  const refetchData = () => {
    fetchDepartments();
  };

  watch([currentPage, perPage, searchQuery, statusFilter, departmentFilter, departmentFilterIsDirector], () => {
    refetchData();
  });

  const statusOptions = [
    { label: 'Đợi duyệt', id: 2 },
    { label: 'Đã kích hoạt', id: 1 },
    { label: 'Chưa kích hoạt', id: 0 },
  ];
  const resolveUserStatusVariant = (status) => {
    if (status === 2) return 'warning';
    if (status === 1) return 'success';
    if (status === 0) return 'secondary';
    return 'primary';
  };
  const resolveUserStatusText = (status) => statusOptions.find((x) => x.id === status).label;
  const resolveTypeText = (type) => typeOptions.find((x) => x.value === type).text;
  const resolveNameLevelText = (name, level) => {
    let i = 2;
    while (i <= level) {
      i++;
      name = ` --- ${name}`;
    }
    return name;
  };

  const confirmDelete = (id) => {
    vm.$swal({
      title: 'Bạn chắc muốn xóa?',
      text: 'Xóa dữ liệu sẽ ảnh hưởng đến các chức năng khác trong hệ thống!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Có',
      cancelButtonText: 'Không',
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-danger ml-1',
      },
      buttonsStyling: false,
    }).then(result => {
      if (result.value) {
        store.dispatch('departments/deleteDepartment', { id }).then((res) => {
          if (res.status === 200) {
            fetchDepartments();
            showToast(res.data.message, { variant: 'success' });
          } else {
            showToast(res.data.message);
          }
        })
      }
    })
  }
  const fetchDepartmentTree = () => {
    console.log('@reloadData="fetchDepartmentTree"');
    loading.value = true;
    store
      .dispatch('departments/fetchDepartmentOptions', {
        parentId: 0,
        isPaginate: 0,
        withParent: 0,
        withChildren: 0,
        deepLevel: 3,
        type: 'tree',
      })
      .then((res) => {
        loading.value = false;
        if (res.status === 200) {
          itemsDataTree.value = res.data.data;
        }
      });
  }

  return {
    loading,
    tableColumns,
    perPage,
    currentPage,
    totalEntries,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    itemsData,
    itemsDataTree,
    fetchDepartmentOptions,
    fetchDepartments,
    fetchDepartmentTree,
    resolveUserStatusVariant,
    resolveUserStatusText,
    refetchData,

    // Extra Filters
    departmentFilter,
    departmentOptions,
    departmentFilterIsDirector,
    statusFilter,
    statusOptions,
    levelOptions,
    typeOptions,
    resolveTypeText,
    resolveNameLevelText,
    normalizerTreeList,
    confirmDelete,
  };
}
